import messages from "messages";
import { Link } from "react-router-dom";

interface ReceiptLinkProps {
  appointment: AppointmentWithSeriesInfo & {
    invoice?: InvoiceData;
  };
  trackClick: (name: string) => void;
}

const ReceiptLink = ({ appointment, trackClick }: ReceiptLinkProps) => (
  <Link
    className={"w-100 btn btn-outline-primary"}
    onClick={() => {
      trackClick("view-receipt-link");
    }}
    to={`/pro-dashboard/invoice/appointment/${appointment.appointment_id}/${appointment.patient.cognito_sub}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    {messages.viewReceipt}
  </Link>
);

export default ReceiptLink;
